import ListItem from "@/entities/PrizificPageBuilder/components/ListItem";
import {
    stepIncrementWidth,
    stepFontSize,
    stepIncrementHeight,
    stepColor,
    stepIncrementBackground,
    stepIncrementColor,
    stepIncrementBorderRadius,
} from "../../GameStepsProperties";

export const thirdGameStep = new ListItem(
    "-",
    "Game step",
    [stepFontSize, stepColor, stepIncrementWidth],
    "",
    [],
    "Őrizd meg a vásárlást igazoló nyugtát vagy számlát, mert annak bemutatása a nyeremény átvételének feltétele.",
    "Őrizd meg a vásárlást igazoló nyugtát vagy számlát, mert annak bemutatása a nyeremény átvételének feltétele.",
    ""
);
